var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"locals"},[_c('idea'),_c('discounts'),_c('joinCTA'),_c('Video',{attrs:{"videoSrc":'https://www.youtube-nocookie.com/embed/J-q2l92XOJI?autoplay=1',"cover":'/img/cover-sztajger.jpg',"coverWEBP":'/img/cover-sztajger.webp'}}),_c('Map'),_c('contactCTA'),_c('contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }